<template>
  <transition name="fade">
    <div v-show="visible" class="monitor-mng">
      <div class="monitor-mng-head" :style="`width:${width}px`">
        <div style="flex:1;"></div>
        <div class="monitor-mng-title">
          <slot name="title">【监控播放器】| {{ title }}</slot>
        </div>
        <div class="monitor-mng-control">
          <i class="el-icon-close" @click="close"></i>
        </div>
      </div>

      <div class="monitor-mng-content" ref="wrap">
        <div
          id="monitor-modal-player"
          :style="`height: ${height}px; width: ${width}px`"
        ></div>

        <div class="monitor-mng-tools" :style="`width:${width}px`">
          <el-button
            v-if="isStop"
            type="text"
            class="video-button"
            icon="el-icon-caret-right"
            :disabled="!isReady"
            @click="play"
          ></el-button>

          <el-button v-else class="video-button" type="text" @click="destroy">
            <svg-icon iconClass="stop"></svg-icon>
          </el-button>

          <el-dropdown
            trigger="click"
            placement="top-start"
            @command="changeHd"
          >
            <span class="definition">{{ isHd ? '超清' : '标清' }}</span>
            <el-dropdown-menu slot="dropdown" class="monitor-dropdown">
              <el-dropdown-item command="0">标清</el-dropdown-item>
              <el-dropdown-item command="1">高清</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import EZUIKit from '@/assets/js/ezuikit@2.js'
import sleep from '@/utlis/sleep'

export default {
  props: { title: String, token: String, camera: Object },
  data() {
    return {
      visible: false,
      width: 0,
      height: 0,
      loading: false,
      isStop: true,
      isReady: false,
      decoder: null,
      isHd: false,
      showDefinition: false
    }
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.keyListener)
  },
  async mounted() {
    window.addEventListener('keyup', this.keyListener)
    await sleep(0.2)
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init() {
      const HEAD_HEIGHT = 60
      const TOOL_HEIGHT = 60
      let height = this.$el.offsetHeight - HEAD_HEIGHT - TOOL_HEIGHT
      let width = Math.floor(height / 9) * 16
      this.width = width
      this.height = height
      if (this.token && this.camera.live) {
        this.initPlayer()
      }
    },
    async close() {
      await this.stop()

      this.visible = false
      setTimeout(() => {
        if (this.$el.parentNode) this.$el.parentNode.removeChild(this.$el)
      }, 200)
    },
    keyListener(evt) {
      switch (evt.keyCode) {
        case 27:
          this.close() // 按键 ESC
          break
      }
    },
    async initPlayer(cb) {
      this.loading = true
      this.isReady = false

      if (this.decoder && !this.isStop) {
        await this.destroy()
      }
      this.decoder = new EZUIKit.EZUIKitPlayer({
        staticPath: '/js',
        id: 'monitor-modal-player',
        autoplay: true,
        audio: false,
        url: this.isHd ? this.camera.hdLive : this.camera.live,
        accessToken: this.token,
        decoderPath: process.env.NODE_ENV === 'production' ? '/v3' : '',
        width: this.width,
        height: this.height,
        splitBasis: 1,
        handleInitSuccess: () => {
          this.loading = false
          this.isReady = true
          this.isStop = false
          if (cb) cb()
        },
        onLoaded: () => {
          this.loading = false
          this.isReady = true
          if (cb) cb()
        },
        handleError: this.handleError,
        handleSuccess: this.handleSuccess
        // handleSelected: this.selectedChange
      })
    },
    async destroy() {
      if (this.decoder) {
        await this.decoder.stop()
        this.isStop = true
        await this.decoder.destroy()
      }
    },
    async stop() {
      if (this.decoder) {
        await this.decoder.stop()
        this.isStop = true
      }
    },
    play() {
      if (this.decoder) {
        this.decoder.play()
        this.isStop = false
      }
    },
    changeHd() {
      this.isHd = !this.isHd
      this.initPlayer()
    }
  }
}
</script>

<style lang="scss">
$head-height: 60px;

#monitor-modal-player {
  width: 100%;
  height: 100%;
  background-color: #000;
}

.monitor-mng {
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: 204;
  /* max-height: calc(100vh - 60px); */
  background-color: rgba(10, 10, 10, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .modal-button {
    z-index: 3;
    position: absolute;
    width: 4rem;
    height: 4rem;
    font-size: 2rem;
    color: #fff;
    background-color: transparent;
    border-width: 2px;
    &.prev {
      left: 2%;
      top: 50%;
    }
    &.next {
      right: 2%;
      top: 50%;
    }
  }

  .monitor-mng-head {
    display: flex;
    justify-content: center;
    height: 60px;
    padding: 0 40px;
    background-color: #606266;
    box-sizing: border-box;
    .monitor-mng-title {
      text-align: center;
      flex: 1;
      font-size: 1.5rem;
      color: #fff;
      line-height: $head-height;
    }
  }
  .monitor-mng-content {
    overflow: hidden;
    width: 100%;
    height: calc(100vh - 60px);
    display: flex;
    justify-content: center;
    align-items: center;
    // position: relative;
    flex-direction: column;
    img {
      width: auto !important;
    }
    .monitor-mng-container {
      z-index: 2;
      position: relative;
      user-select: none;
    }
    .monitor-mng-tools {
      height: $head-height;
      line-height: $head-height;
      background-color: #606266;
    }
    .video-button {
      font-size: 24px;
      color: #fff;
      min-width: 54px !important;
      height: calc(100% - 2px);
      line-height: $head-height;
      cursor: pointer;
      text-align: center;
      padding: 0;
      &:hover {
        box-shadow: 1px 1px 4px #000;
      }
      &:active {
        color: #409eff;
        box-shadow: 0 0 4px #000 inset;
      }
    }
    .video-button.shadow-none:hover {
      box-shadow: none !important;
    }
  }

  .monitor-mng-control {
    flex: 1;
    font-size: 1.5rem;
    color: #fff;
    line-height: $head-height;
  }
  .monitor-mng-control {
    color: #fff;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    i {
      cursor: pointer;
      line-height: $head-height;
      font-size: 1.5rem;
      &:not(:first-child) {
        margin-left: 1rem;
      }
    }
    .el-button-group i {
      line-height: 16px !important;
    }
  }
}
.definition {
  padding: 4px;
  font-size: 16px;
  border: 1px solid #d1d1d1;
  border-radius: 4px;
  font-weight: 200;
  color: #409eff;
  cursor: pointer;
  user-select: none;
}
.monitor-dropdown {
  max-height: none !important;
  overflow: hidden !important;
}
</style>
